module.exports = __webpack_public_path__ + "static/img/model2-5.41ace569.jpg";